import { Box, Typography } from "@mui/material";
import React from "react";

const ExecutiveInsightsPage: React.FC = () => {
  document.title = "Executive Insights";

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        height: "100vh",
        textAlign: "center",
      }}
    >
      <Typography
        variant="h4"
        sx={{
          px: 2,
          maxWidth: "100%",
          "@media (min-width: 1024px)": {
            maxWidth: "40%",
          },
        }}
        gutterBottom
      >
        “This is no ordinary mango” Narada replied, “This is the golden mango of
        knowledge and whoever eats this mango will be granted eternal knowledge
        and wisdom." 🥭
      </Typography>
    </Box>
  );
};

export default ExecutiveInsightsPage;
